import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { contactData } from '../data/mock';
import { Instagram, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      rights: 'All rights reserved.',
      hours: 'Hours',
      contact: 'Contact',
      follow: 'Follow Us'
    },
    fr: {
      rights: 'Tous droits réservés.',
      hours: 'Horaires',
      contact: 'Contact',
      follow: 'Suivez-nous'
    }
  };

  const t = translations[language];
  const hours = language === 'en' ? contactData.hours.en : contactData.hours.fr;

  return (
    <footer className="bg-[#0a1929] border-t border-[#c9a961]/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/krpy34tr_Final_Logo_Sids_Deli-removebg-preview.png" 
              alt="Sid's Deli" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-white/60 text-sm">
              {language === 'en' 
                ? 'Authentic East Coast deli in the heart of Bordeaux, France.' 
                : 'Sandwicherie américaine authentique au cœur de Bordeaux, France.'}
            </p>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-[#c9a961] font-bold text-lg mb-4">{t.hours}</h3>
            <div className="space-y-2 text-white/70 text-sm">
              <div className="grid grid-cols-2 gap-x-3 gap-y-1">
                <span className="text-red-400">{language === 'en' ? 'Mon' : 'Lun'}:</span>
                <span className="text-red-400">{hours.monday}</span>
                
                <span>{language === 'en' ? 'Tue' : 'Mar'}:</span>
                <span>{hours.tuesday}</span>
                
                <span>{language === 'en' ? 'Wed' : 'Mer'}:</span>
                <span>{hours.wednesday}</span>
                
                <span>{language === 'en' ? 'Thu' : 'Jeu'}:</span>
                <span>{hours.thursday}</span>
                
                <span>{language === 'en' ? 'Fri' : 'Ven'}:</span>
                <span>{hours.friday}</span>
                
                <span>{language === 'en' ? 'Sat' : 'Sam'}:</span>
                <span>{hours.saturday}</span>
                
                <span>{language === 'en' ? 'Sun' : 'Dim'}:</span>
                <span>{hours.sunday}</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#c9a961] font-bold text-lg mb-4">{t.contact}</h3>
            <div className="space-y-3 text-white/70 text-sm">
              <a 
                href={`tel:${contactData.phone}`} 
                className="flex items-center space-x-2 hover:text-[#c9a961] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span>{contactData.phone}</span>
              </a>
              <a 
                href={`mailto:${contactData.email}`} 
                className="flex items-center space-x-2 hover:text-[#c9a961] transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>{contactData.email}</span>
              </a>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span>{contactData.address.street}, {contactData.address.city}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#c9a961]/20 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} Sid's Deli. {t.rights}
          </p>
          
          {/* Social Links */}
          <div className="flex items-center space-x-4">
            <span className="text-white/60 text-sm">{t.follow}:</span>
            <a 
              href={`https://instagram.com/${contactData.instagram}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;